import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/healthcare/healthcare-management";

export const Route = createFileRoute(
  "/admin/_modules/_healthcare/healthcare-management"
)({
  component: Page,
});
